module.exports = __webpack_public_path__ + "media/customizations/beaumont/back-fa34b73d9560e089fc8f4df0d2ff6e66.jpg";